<template>
  <main class="transaction-location">
    <span>transaction location</span>
    <div class="location-dropdown-wrapper">
      <sb-async-dropdown
        :headerRows="locationDropdown.headerRows"
        :rows="locationDropdown.rows"
        :options="locationDropdown.options"
        :focused.sync="locationDropdown.focused"
        :selected.sync="locationDropdown.selected"
        @selectedRow="selectedState"
        @deselectedRow="deselectedState"
        class="location-dropdown"
      />
      <div class="location-preview">
        <template v-if="locationPreview">
          <strong style="padding-right: 10px">locations: </strong>
          <span>{{ locationPreview.join(", ") }}</span>
        </template>
      </div>
    </div>
  </main>
</template>

<script>
import { debounce } from "lodash";
import { groupsAPI } from '../../services/api/groupsAPI.js';

export default {
  props: {
    locationsSegment: Object,
    scopeSelectedSegmentIds: Array
  },

  name: "transaction-location",

  data() {
    return {
      locationDropdown: {
        focused: false,
        options: {
          label(selected, focused) {
            return "locations";
          }
        },
        rows: ["loading-row"],
        headerRows: [],
        selected: []
      }
    }
  },

  created() {
    this.getTransactionLocations();
    if(this.locationsSegment?.merchant_segment_ids?.length > 0) {
      this.locationsSegment.merchant_segment_ids.forEach((id, index) => {
        this.locationDropdown.selected.push({
          id: id,
          label: this.locationsSegment.display_names[index],
          root: id
        })
      })
    }
  },

  computed: {
    locationPreview() {
      const locations = this.locationDropdown.selected;
      return (locations?.length > 0) ? locations.map(location => location.label) : null;
    }
  },

  methods: {
    createRows(rows) {
      return rows.map(location => ({
                slot: 'toggle-row',
                state: {
                  id: location.id,
                  label: location.name,
                  root: location.id
                }
              }));
    },

    deselectedState(state) {
      const scopedSelectedSegmentIds = this.scopeSelectedSegmentIds,
            updatedIds = scopedSelectedSegmentIds.filter(segmentId => segmentId !== state.id);

      this.$emit("updateScope", { merchant_segment_ids: updatedIds });
    },

    selectedState(state){
      const scopedSelectedSegmentIds = this.scopeSelectedSegmentIds;

      scopedSelectedSegmentIds.push(state.id);
      this.$emit("updateScope", { merchant_segment_ids: scopedSelectedSegmentIds });
    },

    async getMerchantSegments(groupId, pageNumber, querySearch = "") {
      try {
        const { merchant_segments } = await groupsAPI.getMerchantSegments(groupId, pageNumber, querySearch);
        return merchant_segments;
      } catch(e) {
        this.$emit("updateApiErrors", e);
      }
    },

    async getTransactionLocations(){
      const merchantSegments = await this.getMerchantSegments(this.locationsSegment.id, 1);
      const queryRow = {
        slot: "query-row",
        state: {
          value: "",
          update: debounce(query => {
            this.processSearchQuery({ segment_id: this.locationsSegment.id, page: 1, query });
            queryRow.state.value = query;
          }, 200)
        }
      };
      this.locationDropdown.headerRows = [queryRow];
      this.locationDropdown.rows = this.createRows(merchantSegments);
    },

    async processSearchQuery(params) {
      const segments = await this.getMerchantSegments(params.segment_id, params.page, params.query);
      this.locationDropdown.rows = this.createRows(segments);
      if(this.locationDropdown.rows.length === 0){
        this.locationDropdown.rows = [{
          slot: "text-row",
          state: {
            message: "no search results"
          }
        }];
      }
    }
  }
};
</script>

<style scoped>
.transaction-location {
  margin-left: 25px;
}

.transaction-location > span {
  display: block;
  font-family: "AileronLight";
  font-size: 1.25em;
  width: 375px;
}

.location-dropdown-wrapper {
  display: flex;
  flex-direction: row;
}

.location-dropdown {
  flex: 0;
  min-width: 200px;
}

.location-preview {
  border-color: #128ff9;
  border-radius: 0 8px 8px 0;
  border-style: solid;
  border-width: 1px 1px 1px 0;
  flex: 1;
  margin-left: -15px;
  overflow: auto;
  padding-left: 30px;
}

.location-dropdown >>> main.label-container {
  padding: 0.85rem;
}

.location-dropdown >>> .label-container,
.location-preview {
  height: 55px;
}

.location-dropdown >>> .text-row,
.location-dropdown >>> .sb-header .clear-search {
  color: #a4a4a4;
  font-size: .9em;
}
</style>